

export const VIEW_TYPE = {
    TRANSACTION: {id: "TRANSACTION"}
}
